module.exports = __webpack_public_path__ + "img/20220624172453.46de36ca.png";